<!-- SUCCESS -->
@if ((toast.toastState$ | async) == 'success' && (toast.showsToast$ | async)) {
  <tds-toast
    variant="success"
    header="Success"
    subheader="{{ toast.toastMessage$ | async }}">
  </tds-toast>
}

<!-- INFORMATION -->
@if ((toast.toastState$ | async) == 'information' && (toast.showsToast$ | async)) {
  <tds-toast
    variant="information"
    header="Information"
    subheader="{{ toast.toastMessage$ | async }}">
  </tds-toast>
}

<!-- WARNING -->
@if ((toast.toastState$ | async) == 'warning' && (toast.showsToast$ | async)) {
  <tds-toast
    variant="warning"
    header="Warning"
    subheader="{{ toast.toastMessage$ | async }}">
  </tds-toast>
}

<!-- ERROR -->
@if ((toast.toastState$ | async) == 'error' && (toast.showsToast$ | async)) {
  <tds-toast
    variant="error"
    header="Error"
    subheader="{{ toast.toastMessage$ | async }}">
  </tds-toast>
}